<template>
  <a-result status="success" title="Successfully upgraded your membership!" sub-title="">
    <template #extra>
      <p>Please re-login to get all permissions</p>
      <a-button key="console" type="primary" @click="logout()"> Logout </a-button>
    </template>
  </a-result>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    gotoDashboard() {
      this.$router.push({ path: '/dashboard' });
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'signIn' });
    },
  },
};
</script>
